import LicenseInfiniteList from './LicenseInfiniteList';
export default LicenseInfiniteList;
